import React from "react";
import "./input.css"; // o tu css correspondiente (puede ser el mismo que Input si aplica)

const Textarea = ({
    placeholder,
    variant = "Simple",
    value,
    onChange,
    onBlur,
    error,
    success,
    rows = 5,
    maxLength = 1000,
}) => {
    return (
        <div className={`input-wrapper ${variant}`}>
            <textarea
                className={`input ${error ? "error" : ""} ${success ? "success" : ""}`}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                rows={rows}
                maxLength={maxLength}
            />
            {error && <small style={{ color: "red" }}>{error}</small>}
        </div>
    );
};

export default Textarea;